import css from './Sidebar.module.css'
import SidebarButtonsWrapper from "./components/SidebarButtonsWrapper/SidebarButtonsWrapper.tsx";
import SidebarWorkspaceButton from "./components/SidebarWorkspaceButton/SidebarWorkspaceButton.tsx";
import SidebarPlateButton from "./components/SidebarPlateButton/SidebarPlateButton.tsx";
import SidebarProjectsButton from "./components/SidebarProjectsButton/SidebarProjectsButton.tsx";
import SidebarAllTasksButton from "./components/SidebarAllTasksButton/SidebarAllTasksButton.tsx";
import SidebarTeamButton from "./components/SidebarTeamButton/SidebarTeamButton.tsx";
import SidebarAuthButton from "./components/SidebarAuthButton/SidebarAuthButton.tsx";
import SidebarSavePopup from "./components/SidebarSavePopup/SidebarSavePopup.tsx";
import SidebarInboxButton from "./components/SidebarInboxButton/SidebarInboxButton.tsx";
import SidebarSearchButton from "./components/SidebarSearchButton/SidebarSearchButton.tsx";
import { useAppSelector } from "../../../store/hooks.ts";
import { selectAuth } from "../../../store/auth/authSelectors.ts";

const Sidebar = () => {
    const auth = useAppSelector(selectAuth)

    return (
        <aside className={css.sidebar}>
            {auth && (
                <SidebarButtonsWrapper>
                    <SidebarWorkspaceButton />
                    <SidebarPlateButton />
                    <SidebarTeamButton />
                    <SidebarProjectsButton />
                    <SidebarAllTasksButton />
                </SidebarButtonsWrapper>
            )}
            <SidebarButtonsWrapper position="bottom">
                <SidebarSavePopup />
                {auth && <SidebarSearchButton />}
                {auth && <SidebarInboxButton />}
                <SidebarAuthButton />
            </SidebarButtonsWrapper>
        </aside>
    )
}

export default Sidebar
